import { Type } from "js-yaml";
import { CUSTOM_TAGS } from "../constants.js";
class ParsedCms {
  key;
  isCmsContent = true;
  contentType = void 0;
  identifier = void 0;
  constructor(key) {
    this.key = key;
    const parts = key.split(":");
    if (parts.length === 2) {
      this.isCmsContent = true;
      this.contentType = parts[0];
      this.identifier = parts[1];
    } else {
      this.isCmsContent = false;
    }
  }
}
const CmsTag = new Type(CUSTOM_TAGS.CMS, {
  kind: "scalar",
  resolve: (data) => data !== null && typeof data === "string",
  construct: (data) => new ParsedCms(data),
  instanceOf: ParsedCms,
  represent: (data) => data.key
});
export {
  CmsTag,
  ParsedCms
};
